import superagent from '@ott/superagent';

const url = '/_hotels_order/public/extraCharge/status';

const getPayStatus = (surchargeId) => {
  return new Promise((resolve) => superagent.get(`${url}/${surchargeId}`).then(resolve));
};

export default getPayStatus;
